import React from 'react';
import RangeInput from './RangeInput';
import {Box} from '@mui/material';

const TimeInputSlider = (props: TimeInputSliderProps) => {
  const {minTime, maxTime} = props;

  const min = React.useRef(minTime / 1000);
  const max = React.useRef(maxTime > minTime ? maxTime / 1000 : minTime / 1000 + 1);
  const [value, setValue] = React.useState(0);

  const handleChange = (value: number) => {
    setValue(value);
    return props.onChange(value * 1000);
  };

  React.useEffect(() => {
    const next = props.value / 1000;
    setValue(Math.min(Math.max(next, min.current), max.current));
  }, [props.value]);

  return (
    <Box sx={{ width: '100%', minWidth: 0 }}>
      <RangeInput min={min.current} max={max.current} onChange={handleChange} value={value} disabled={props.disabled} />
    </Box>
  );
};

export default TimeInputSlider;

type TimeInputSliderProps = {
  minTime: number;
  maxTime: number;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
};
